import { AuditType } from "../~store/models/enums/AuditTypes";
import i18n from "src/app/shared/localization/i18n";

export const ConvertFromFilterToAuditStatus = (filter: string) : any => {
    let status = "";
    switch (filter) {
        case i18n.t('audit.operatorConnectedBySignalR'):
            status = AuditType[AuditType.OperatorConnectedBySignalR];
            break;
        case i18n.t('audit.operatorDisconnectedBySignalR'):
            status = AuditType[AuditType.OperatorDisconnectedBySignalR];
            break;
        case i18n.t('audit.operatorWentOnline'):
            status = AuditType[AuditType.OperatorWentOnline];
            break;
        case i18n.t('audit.operatorWentPause'):
            status = AuditType[AuditType.OperatorWentPause];
            break;
        case i18n.t('audit.operatorWentOffline'):
            status = AuditType[AuditType.OperatorWentOffline];
            break;
        case i18n.t('audit.createSetting'):
            status = AuditType[AuditType.CreateSetting];
            break;
        case i18n.t('audit.updateSetting'):
            status = AuditType[AuditType.UpdateSetting];
            break;
        case i18n.t('audit.removeSetting'):
            status = AuditType[AuditType.RemoveSetting];
            break;
        case i18n.t('audit.createChannel'):
            status = AuditType[AuditType.CreateChannel];
            break;
        case i18n.t('audit.updateChannel'):
            status = AuditType[AuditType.UpdateChannel];
            break;
        case i18n.t('audit.removeChannel'):
            status = AuditType[AuditType.RemoveChannel];
            break;
        case i18n.t('audit.createOperator'):
            status = AuditType[AuditType.CreateOperator];
            break;
        case i18n.t('audit.updateOperator'):
            status = AuditType[AuditType.UpdateOperator];
            break;
        case i18n.t('audit.removeOperator'):
            status = AuditType[AuditType.RemoveOperator];
            break;
        case i18n.t('audit.operatorWentPause1'):
            status = AuditType[AuditType.OperatorWentPause1];
            break;
        case i18n.t('audit.operatorWentPause2'):
            status = AuditType[AuditType.OperatorWentPause2];
            break;
        case i18n.t('audit.operatorWentPause3'):
            status = AuditType[AuditType.OperatorWentPause3];
            break;
        case i18n.t('audit.operatorWentPause4'):
            status = AuditType[AuditType.OperatorWentPause4];
            break;
        case i18n.t('audit.operatorWentPause5'):
            status = AuditType[AuditType.OperatorWentPause5];
            break;
        case i18n.t('audit.operatorWentPause6'):
            status = AuditType[AuditType.OperatorWentPause6];
            break;
        case i18n.t('audit.operatorWentPause7'):
            status = AuditType[AuditType.OperatorWentPause7];
            break;
        case i18n.t('audit.operatorWentPause8'):
            status = AuditType[AuditType.OperatorWentPause8];
            break;
        case i18n.t('audit.operatorWentPause9'):
            status = AuditType[AuditType.OperatorWentPause9];
            break;
        case i18n.t('audit.operatorWentPause10'):
            status = AuditType[AuditType.OperatorWentPause10];
            break;
    }
    return status;
}

export const ConvertFromAuditStatus = (status: AuditType) : any => {
    let localizedStatus = "";
    switch (status) {
        case AuditType.OperatorConnectedBySignalR:
            localizedStatus = i18n.t('audit.operatorConnectedBySignalR');
            break;
        case AuditType.OperatorDisconnectedBySignalR:
            localizedStatus = i18n.t('audit.operatorDisconnectedBySignalR');
            break;
        case AuditType.OperatorWentOnline:
            localizedStatus = i18n.t('audit.operatorWentOnline');
            break;
        case AuditType.OperatorWentPause:
            localizedStatus = i18n.t('audit.operatorWentPause');
            break;
        case AuditType.OperatorWentOffline:
            localizedStatus = i18n.t('audit.operatorWentOffline');
            break;
        case AuditType.CreateSetting:
            localizedStatus = i18n.t('audit.createSetting');
            break;
        case AuditType.UpdateSetting:
            localizedStatus = i18n.t('audit.updateSetting');
            break;
        case AuditType.RemoveSetting:
            localizedStatus = i18n.t('audit.removeSetting');
            break;
        case AuditType.CreateChannel:
            localizedStatus = i18n.t('audit.createChannel');
            break;
        case AuditType.UpdateChannel:
            localizedStatus = i18n.t('audit.updateChannel');
            break;
        case AuditType.RemoveChannel:
            localizedStatus = i18n.t('audit.removeChannel');
            break;
        case AuditType.CreateOperator:
            localizedStatus = i18n.t('audit.createOperator');
            break;
        case AuditType.UpdateOperator:
            localizedStatus = i18n.t('audit.updateOperator');
            break;
        case AuditType.RemoveOperator:
            localizedStatus = i18n.t('audit.removeOperator');
            break;
        case AuditType.OperatorWentPause1:
            localizedStatus = i18n.t('audit.operatorWentPause1');
            break;
        case AuditType.OperatorWentPause2:
            localizedStatus = i18n.t('audit.operatorWentPause2');
            break;
        case AuditType.OperatorWentPause3:
            localizedStatus = i18n.t('audit.operatorWentPause3');
            break;
        case AuditType.OperatorWentPause4:
            localizedStatus = i18n.t('audit.operatorWentPause4');
            break;
        case AuditType.OperatorWentPause5:
            localizedStatus = i18n.t('audit.operatorWentPause5');
            break;
        case AuditType.OperatorWentPause6:
            localizedStatus = i18n.t('audit.operatorWentPause6');
            break;
        case AuditType.OperatorWentPause7:
            localizedStatus = i18n.t('audit.operatorWentPause7');
            break;
        case AuditType.OperatorWentPause8:
            localizedStatus = i18n.t('audit.operatorWentPause8');
            break;
        case AuditType.OperatorWentPause9:
            localizedStatus = i18n.t('audit.operatorWentPause9');
            break;
        case AuditType.OperatorWentPause10:
            localizedStatus = i18n.t('audit.operatorWentPause10');
            break;
    }
    return localizedStatus;
}